import { render } from "./ProfomaPage.vue?vue&type=template&id=0267617d"
import script from "./ProfomaPage.vue?vue&type=script&lang=js"
export * from "./ProfomaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__